export const CHARS = 'abcdefghijklmnopqrstuvwxyz'

export const charAt = (index: number) => CHARS[index].toUpperCase()
